module.exports = __webpack_public_path__ + "media/assets/icons/file-text2-bluegray-500-986ebd5fbb3b1b136e7b3aacdcad6b91.svg";